import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../components/v-pay.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
